/**
 * Angular 2 decorators and services
 */
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from 'environments/environment';
import { ImageReadyService } from './providers/';
/**
 * App Component
 * Top Level Component
 */
@Component({
  selector: 'app',
  styleUrls: [
    './app.component.css'
  ],
  encapsulation: ViewEncapsulation.None,
  template: `
    <ng-container *ngIf="showLoading">
      <div class="loading-backdrop">
        <span class="spinner"></span>
        <span *ngIf="progress && progress.length" class="progress">{{progress[0].progress}}</span>
      </div>
    </ng-container>
    <router-outlet></router-outlet>
  `
})
export class AppComponent implements OnInit {
  showLoading: boolean = false;
  progress: any;
  constructor(private irs: ImageReadyService) {
    this.progress = null;
  }

  public ngOnInit() {
    this.irs.ready.subscribe((isReady: boolean) => {
      this.showLoading = !isReady;
    });
    this.irs.progress.subscribe((progress: any) => {
      this.progress = progress;
    });
  }

}

/**
 * Please review the https://github.com/AngularClass/angular-examples/ repo for
 * more angular app examples that you may copy/paste
 * (The examples may not be updated as quickly. Please open an issue on github for us to update it)
 * For help or questions please contact us at @AngularClass on twitter
 * or our chat on Slack at https://AngularClass.com/slack-join
 */



// WEBPACK FOOTER //
// ./src/app/app.component.ts